export const TRENDING_TOPICS_COUNT = 4;
export const TRENDING_TOPIC_ABIOCHAT = 'Chat';

export const isFileUplaodEnabled= true;